module.exports = __webpack_public_path__ + "img/Frame 718.4315abf0.png";